function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
export { _isNativeReflectConstruct as default };


//////////////////
// WEBPACK FOOTER
// ./~/_@babel_runtime@7.29.7@@babel/runtime/helpers/esm/isNativeReflectConstruct.js
// module id = 359
// module chunks = 49